var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form"},[_c('div',{staticClass:"row"},[_c('label',[_vm._v("公开主页")]),_c('input',{attrs:{"type":"checkbox"}})]),_c('div',{staticClass:"row"},[_c('label',[_vm._v("谁可私信")]),_c('select',[_c('option',[_vm._v("所有人")]),_c('option',[_vm._v("仅好友")]),_c('option',[_vm._v("关闭")])])])])
}]

export { render, staticRenderFns }